import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type SitePageContentType =
  | "static"
  | "template"
  | "contact"
  | "library"
  | "category"
  | "calendar"
  | "program"
  | "ai_tutor";

export type SitePageVisibility = "public" | "authenticated" | "roles";

export type SitePageRow = {
  key: string;
  name: string;
  name_es: string | null;
  url: string;
  is_active: boolean;
  is_toggleable: boolean;
  category: string | null;
  description: string | null;
  content_type: SitePageContentType;
  content_config: Record<string, any> | null;
  visibility: SitePageVisibility;
  allowed_roles: string[] | null;
  content_changed_at: string | null;
};

export function useSitePages() {
  return useQuery({
    queryKey: ["site-pages"],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await (supabase.from as any)("site_pages").select("*");
      if (error) throw error;
      return (data ?? []) as SitePageRow[];
    },
  });
}

export function useSitePage(key: string) {
  const query = useSitePages();
  return {
    ...query,
    page: (query.data || []).find((p) => p.key === key) || null,
  };
}
